import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["Trend"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      postTrendCalculate: build.mutation<
        PostTrendCalculateApiResponse,
        PostTrendCalculateApiArg
      >({
        query: (queryArg) => ({
          url: `/Trend/Calculate`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["Trend"],
      }),
      getTrendList: build.query<GetTrendListApiResponse, GetTrendListApiArg>({
        query: () => ({ url: `/Trend/List` }),
        providesTags: ["Trend"],
      }),
      postTrendGetTable: build.query<
        PostTrendGetTableApiResponse,
        PostTrendGetTableApiArg
      >({
        query: (queryArg) => ({
          url: `/Trend/GetTable`,
          method: "POST",
          body: queryArg,
        }),
        providesTags: ["Trend"],
      }),
      postTrendGetGraph: build.query<
        PostTrendGetGraphApiResponse,
        PostTrendGetGraphApiArg
      >({
        query: (queryArg) => ({
          url: `/Trend/GetGraph`,
          method: "POST",
          body: queryArg,
        }),
        providesTags: ["Trend"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as trendApi };
export type PostTrendCalculateApiResponse = /** status 200 OK */ void;
export type PostTrendCalculateApiArg = TrendCalculationRequestDto;
export type GetTrendListApiResponse = /** status 200 OK */ AnalysisRequestDto[];
export type GetTrendListApiArg = void;
export type PostTrendGetTableApiResponse =
  /** status 200 OK */ CellValueDto[][];
export type PostTrendGetTableApiArg = TrendTableRequestDto;
export type PostTrendGetGraphApiResponse =
  /** status 200 OK */ TrendValueListDto[];
export type PostTrendGetGraphApiArg = TrendGraphRequestDto;
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type TrendCalculationRequestDto = {
  name: string;
  start: string;
  end: string;
  dataFields?: string[] | null;
  measuringPoints?: string[] | null;
};
export type ServiceType =
  | "jobPrepareOrFinishe"
  | "datacollector"
  | "irregulardatachecker"
  | "correlationcalculator"
  | "quantilecalculator"
  | "anomalycalculator"
  | "correlationresultcalculator"
  | "trendscalculator"
  | "correlationresultaggregator"
  | "anomalyscorecalculator"
  | "non";
export type CorrelationCalculationType =
  | "non"
  | "betweenMessstellen"
  | "betweenKenngroessen"
  | "all";
export type CorrelationResultType = "single" | "count" | "percentage";
export type AnalysisRequestDto = {
  id: number;
  name: string;
  start: string;
  end: string;
  measuringPoints?: string[] | null;
  dataFields?: string[] | null;
  serviceType?: ServiceType;
  correlationType?: CorrelationCalculationType;
  correlationResultType?: CorrelationResultType;
  coefficientMinimum?: number | null;
  coefficientMaximum?: number | null;
  isVisible?: boolean;
  isDeletable?: boolean;
};
export type CellValueDto = {
  row: string;
  col: string;
  value?: number | null;
};
export type TrendTableRequestDto = {
  analysisRequestId: number;
  dataFields?: string[] | null;
  measuringPoints?: string[] | null;
  currentValueMin?: number | null;
  currentValueMax?: number | null;
  increaseMin?: number | null;
  increaseMax?: number | null;
  increaseDurationMin?: number | null;
  increaseDurationMax?: number | null;
  averageIncreaseMin?: number | null;
  averageIncreaseMax?: number | null;
};
export type DataPointDto = {
  time: string;
  value: number;
};
export type TrendValueListDto = {
  id: number;
  dataPoints: DataPointDto[];
  lastExtremum?: number;
};
export type TrendGraphRequestDto = {
  analysisRequestId: number;
  measuringPoint?: string | null;
  analysisCategory?: string | null;
};
export const {
  usePostTrendCalculateMutation,
  useGetTrendListQuery,
  useLazyGetTrendListQuery,
  usePostTrendGetTableQuery,
  useLazyPostTrendGetTableQuery,
  usePostTrendGetGraphQuery,
  useLazyPostTrendGetGraphQuery,
} = injectedRtkApi;
